<template>
  <div class="modal inmodal in" tabindex="-1" :style="display">
    <div class="modal-dialog">
      <div class="modal-content animated fadeIn">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal"
          >
            <span aria-hidden="true">&times;</span>
            <span class="sr-only">
              Close
            </span>
          </button>
          <i class="fa fa-unlock modal-icon"></i>
          <h4 class="modal-title">Reativar Pagamento</h4>
          <small></small>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-white"
            data-dismiss="modal"
            @click="closeModal"
          >
            Cancelar
          </button>

          <button
            :disabled="isSubmitDisabled"
            type="button"
            class="btn btn-success"
            @click="confirmAction"
          >
            Confirmar Reativação
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      default: false,
    },
    paymentInfo: {
      default: () => ({}),
    },
  },
  data() {
    return {
      reason: '',
      showError: false,
      isSubmitDisabled: false,
    };
  },
  computed: {
    display() {
      return this.show ? 'display: block' : 'display: none';
    },
  },
  methods: {
    cleanFields() {
      this.reason = '';
      this.showError = false;
    },
    closeModal() {
      this.cleanFields();
      this.$emit('close-modal');
    },
    async confirmAction() {
      const payload = {
        paymentId: this.paymentInfo._id,
      };

      try {
        this.isSubmitDisabled = true;
        await this.$store.dispatch('REACTIVE-PAYMENT/AuthorizePayment', payload);
        this.$toasted.success('Pagamento reativado com sucesso');
      } catch (error) {
        this.$toasted.error(error);
      } finally {
        this.isSubmitDisabled = false;
        this.cleanFields();
        this.$emit('close-modal', { refresh: true });
      }
    },
  },
};
</script>
